import { render } from "./template.html?vue&type=template&id=58c530cb&scoped=true"
import script from "./fullStories.vue?vue&type=script&lang=js"
export * from "./fullStories.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=58c530cb&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c530cb"]])

export default __exports__